export default __webpack_public_path__ + "static/media/utr.3cf788be.woff2";